import i18n from "@helpers/lib/i18n";
import { formatNumber } from "@memorang/helpers/common";
import pluralize from "pluralize";

export const generatePracticeTestSubtitle = ({
	numPracticeTests,
	numQuiz,
	practiceTestLabel,
	diagnosticLabel,
}: {
	numPracticeTests: number;
	numQuiz: number;
	practiceTestLabel: string | undefined;
	diagnosticLabel: Record<string, string> | undefined;
}) => {
	const testPart = `${formatNumber(numPracticeTests)} ${pluralize(practiceTestLabel?.toLocaleLowerCase() ?? "practice test", numPracticeTests)}`;
	const quizPart = numQuiz
		? ` • ${formatNumber(numQuiz)} ${pluralize(diagnosticLabel ? diagnosticLabel[i18n.language] : "diagnostic", numQuiz)}`
		: "";
	return `${testPart}${quizPart}`;
};
